export default __webpack_public_path__ + "static/media/Marketplace.abe9acae.svg";